import { isNil } from 'ramda'

import { Typography } from '@twisto/components/atoms/typography'

import type { RichTextBlock } from '../rich-text.d'
import { useRichText } from '../rich-text.hook'

type Props = {
  content: RichTextBlock['children']
  level: RichTextBlock['level']
  className?: string
}

// Component library only supports h1, h2, h3
const MAX_LEVEL = 3

export const Headline = ({ content, level, className }: Props) => {
  const { renderChildren } = useRichText()
  let variant = `h${level}` as 'h1' | 'h2' | 'h3'

  if (isNil(level) || level > MAX_LEVEL) {
    variant = 'h3'
  }

  return (
    <Typography
      className={className}
      color="textPrimary"
      component={variant}
      variant={variant}
    >
      {renderChildren(content)}
    </Typography>
  )
}
